
<div class="header">
  <p>Verificación</p>
  <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
</div>
<div class="body text-center">
  <p class="fs-17 fw-sbold">Ingresa tu MoNIP</p>
  <ng-otp-input (onInputChange)="checkNip($event)" [config]="otpInputConfig"></ng-otp-input>
</div>
